{
  "breaches": {
    "count": "Your account details have been leaked in {count} data breaches.",
    "discovered": "This breach was first discovered on {date}.",
    "empty": {
      "text": "We have not found any data leaks for your account.",
      "title": "No data leaks found"
    },
    "high": "High",
    "medium": "Medium",
    "title": "Breaches",
    "watchlist": {
      "button": "Add email",
      "text": "Emails being monitored",
      "title": "Watchlist"
    }
  },
  "cards": {
    "breaches": {
      "text": "You can check the number of data breaches your account has been involved in on this page. We categorize the data breaches by their severity and the kind of data that was leaked. Make sure to change your passwords if your data has been exposed in a data breach.",
      "title": "Has your data been leaked?"
    },
    "overview": {
      "text": "Hey {name}! As you may know, phishing attacks are becoming increasingly complex and dangerous. The Hub is the place to track your progress and learn even more about the cyberattacks that threaten your company. Complete security achievements and become a security expert in no time.",
      "title": "Welcome to The Hub!"
    },
    "quiz": {
      "text": "Embark on the interactive quiz journey and challenge your skills to distinguish between genuine and phishing emails. The quiz is designed to test your knowledge and understanding of the threats that exist in the real world.",
      "title": "Lets quiz you!"
    },
    "simulations": {
      "text": "On this page you can view the details of the simulations you have received by Moxso in the past 90 days. By understanding how phishing e-mail are designed, you will be able to identify and protect yourself from them.",
      "title": "Have you been phished?"
    },
    "videos": {
      "text": "On this page you can watch videos about the latest cyber threats and learn how to protect yourself and your company from them. Our training videos are available for you to watch whenever you want.",
      "title": "Ready, set, action!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certificate of completion",
    "certificate_unlocked": "Certficate unlocked",
    "share_on_linkedin": "Share on LinkedIn",
    "show_certificate": "Show certificate",
    "text": "You have a certificate from a recent course. Why don't you show it off?"
  },
  "courses": {
    "all": "All courses",
    "completed": {
      "badge": "Completed",
      "button": "Complete course",
      "text": "You have completed the course",
      "title": "Nicely done!"
    },
    "content": {
      "breach": {
        "text": "Enable breach detection for your account",
        "title": "Setup breach detection"
      },
      "download": {
        "button": "Download"
      },
      "introduction": {
        "contents": "Contents",
        "start": "Start course",
        "text": "Course introduction and overview",
        "title": "Introduction"
      },
      "quiz": {
        "choose_answer": "Choose the correct answer below:",
        "correct": "Correct",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Correct answer",
        "next_question": "Next question",
        "oh_no": "Bummer!",
        "question_of": "Question {current} of {total}",
        "result": {
          "button": "Complete quiz",
          "text": "You answered {correct} out of {total} questions correctly.",
          "title": "Well done!",
          "title_fail": "Almost there!"
        },
        "text": "Put your skills to the test with a quiz",
        "title": "Quiz",
        "view_results": "View result",
        "well_done": "Well done!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Your answer"
      },
      "video": {
        "text": "Learn the key concepts by watching this video"
      }
    },
    "continue": "Continue",
    "featured": "Featured courses",
    "lessons": "{count} lessons",
    "progress": {
      "button": "Continue",
      "text": "You have completed {pct}% of this course"
    },
    "skip_video": {
      "button": "Skip",
      "text": "You've watched this video before. Skip it?"
    },
    "start_over": "Start over",
    "title": "Courses"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "The question has expired",
        "network": "An error has occurred",
        "noResponse": "No response was received from the server",
        "streaming": {
          "manifest": "An error occurred while playing the video",
          "platform": "This video is not supported on your device",
          "unavailable": "This video is not available"
        },
        "unknown": "An unknown error has occurred"
      },
      "messages": {
        "auth_failed": "Invalid email",
        "csrf": "Refresh the page and try again",
        "email_missing": "No email address associated with account",
        "file_not_found": "File not found",
        "general_exception": "An error has occurred",
        "invalid_answer": "Invalid answer",
        "invalid_course": "Invalid course",
        "invalid_domain": "Invalid domain",
        "invalid_email": "Invalid email",
        "invalid_grant": "Could not contact the provider",
        "invalid_locale": "Translation not found",
        "invalid_option": "Invalid option",
        "invalid_permissions": "You are not authorized to use this feature",
        "invalid_point": "Invalid point",
        "invalid_provider": "Invalid provider",
        "invalid_quiz": "Invalid quiz",
        "invalid_token": "Your session has expired",
        "invalid_video": "Invalid video",
        "missing_code": "Please try again",
        "two_factor_code_expired": "Two factor code expired",
        "two_factor_code_invalid": "Two factor code is invalid",
        "unauthorized": "You are not authorized to use this feature",
        "user_not_found": "The user does not exist"
      },
      "validations": {
        "messages": {
          "throttle": "Too many login attempts. Please try again later."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Account balances",
        "address_book_contacts": "Address book contacts",
        "age_groups": "Age groups",
        "ages": "Ages",
        "appointments": "Appointments",
        "apps_installed_on_devices": "Apps installed on devices",
        "astrological_signs": "Astrological signs",
        "audio_recordings": "Audio recordings",
        "auth_tokens": "Auth tokens",
        "avatars": "Avatars",
        "bank_account_numbers": "Bank account numbers",
        "beauty_ratings": "Beauty ratings",
        "biometric_data": "Biometric data",
        "bios": "Bios",
        "browser_user_agent_details": "Browser user agent details",
        "browsing_histories": "Browsing histories",
        "buying_preferences": "Buying preferences",
        "car_ownership_statuses": "Car ownership statuses",
        "career_levels": "Career levels",
        "cellular_network_names": "Cellular network names",
        "charitable_donations": "Charitable donations",
        "chat_logs": "Chat logs",
        "credit_card_cvv": "Credit card CVV",
        "credit_cards": "Credit cards",
        "credit_status_information": "Credit status information",
        "customer_feedback": "Customer feedback",
        "customer_interactions": "Customer interactions",
        "dates_of_birth": "Dates of birth",
        "deceased_date": "Deceased date",
        "deceased_statuses": "Deceased statuses",
        "device_information": "Device information",
        "device_serial_numbers": "Device serial numbers",
        "device_usage_tracking_data": "Device usage tracking data",
        "drinking_habits": "Drinking habits",
        "driver_s_licenses": "Driver's licenses",
        "drug_habits": "Drug habits",
        "eating_habits": "Eating habits",
        "education_levels": "Education levels",
        "email_addresses": "Email addresses",
        "email_messages": "Email messages",
        "employers": "Employers",
        "employment_statuses": "Employment statuses",
        "encrypted_keys": "Encrypted keys",
        "ethnicities": "Ethnicities",
        "family_members_names": "Family members' names",
        "family_plans": "Family plans",
        "family_structure": "Family structure",
        "financial_investments": "Financial investments",
        "financial_transactions": "Financial transactions",
        "fitness_levels": "Fitness levels",
        "genders": "Genders",
        "geographic_locations": "Geographic locations",
        "government_issued_i_ds": "Government issued IDs",
        "health_insurance_information": "Health insurance information",
        "historical_passwords": "Historical passwords",
        "hiv_statuses": "HIV statuses",
        "home_loan_information": "Home loan information",
        "home_ownership_statuses": "Home ownership statuses",
        "homepage_ur_ls": "Homepage URLs",
        "imei_numbers": "IMEI numbers",
        "imsi_numbers": "IMSI numbers",
        "income_levels": "Income levels",
        "instant_messenger_identities": "Instant messenger identities",
        "ip_addresses": "IP addresses",
        "job_applications": "Job applications",
        "job_titles": "Job titles",
        "licence_plates": "Licence plates",
        "living_costs": "Living costs",
        "login_histories": "Login histories",
        "mac_addresses": "MAC addresses",
        "marital_statuses": "Marital statuses",
        "mnemonic_phrases": "Mnemonic phrases",
        "mothers_maiden_names": "Mothers maiden names",
        "names": "Names",
        "nationalities": "Nationalities",
        "net_worths": "Net worths",
        "nicknames": "Nicknames",
        "occupations": "Occupations",
        "parenting_plans": "Parenting plans",
        "partial_credit_card_data": "Partial credit card data",
        "partial_dates_of_birth": "Partial dates of birth",
        "passport_numbers": "Passport numbers",
        "password_hints": "Password hints",
        "password_strengths": "Password strengths",
        "passwords": "Passwords",
        "payment_histories": "Payment histories",
        "payment_methods": "Payment methods",
        "personal_descriptions": "Personal descriptions",
        "personal_health_data": "Personal health data",
        "personal_interests": "Personal interests",
        "phone_numbers": "Phone numbers",
        "photos": "Photos",
        "physical_addresses": "Physical addresses",
        "physical_attributes": "Physical attributes",
        "pi_ns": "PINs",
        "places_of_birth": "Places of birth",
        "political_donations": "Political donations",
        "political_views": "Political views",
        "private_messages": "Private messages",
        "professional_skills": "Professional skills",
        "profile_photos": "Profile photos",
        "purchases": "Purchases",
        "purchasing_habits": "Purchasing habits",
        "races": "Races",
        "recovery_email_addresses": "Recovery email addresses",
        "relationship_statuses": "Relationship statuses",
        "religions": "Religions",
        "reward_program_balances": "Reward program balances",
        "salutations": "Salutations",
        "school_grades_class_levels": "School grades (class levels)",
        "security_questions_and_answers": "Security questions and answers",
        "sexual_fetishes": "Sexual fetishes",
        "sexual_orientations": "Sexual orientations",
        "smoking_habits": "Smoking habits",
        "sms_messages": "SMS messages",
        "social_connections": "Social connections",
        "social_media_profiles": "Social media profiles",
        "social_security_numbers": "Social security numbers",
        "spoken_languages": "Spoken languages",
        "spouses_names": "Spouses names",
        "support_tickets": "Support tickets",
        "survey_results": "Survey results",
        "taxation_records": "Taxation records",
        "telecommunications_carrier": "Telecommunications carrier",
        "time_zones": "Time zones",
        "travel_habits": "Travel habits",
        "user_statuses": "User statuses",
        "user_website_ur_ls": "User website URLs",
        "usernames": "Usernames",
        "utility_bills": "Utility bills",
        "vehicle_details": "Vehicle details",
        "website_activity": "Website activity",
        "work_habits": "Work habits",
        "years_of_professional_experience": "Years of professional experience"
      }
    },
    "certificates": {
      "compliance": "Cybersecurity Training"
    },
    "courses": {
      "toc": {
        "breach-content": "Date breaches",
        "file-content": "Download",
        "intro-content": "Introduction",
        "quiz-content": "Quiz",
        "text-content": "Case",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "English",
      "da_DK": "Danish",
      "de_DE": "German",
      "en_US": "English",
      "es_ES": "Spanish",
      "fi_FI": "Finnish",
      "fr_FR": "French",
      "nb_NO": "Norwegian",
      "nl_NL": "Dutch",
      "pl_PL": "Polish",
      "pt_PT": "Portuguese",
      "sv_SE": "Swedish"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Greetings and welcome to your personalized learning platform! We are delighted to have you join us and are eager to assist you in attaining your learning objectives.",
              "title": "Welcome to Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "How Moxso works",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Let's get started 🙌\n",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Data Privacy Awareness",
          "options": {
            "high": "Familiar",
            "low": "Not familiar",
            "medium": "Somewhat familiar"
          },
          "question": "How familiar are you with the basic principles of data privacy (e.g., GDPR)?"
        },
        "device_security": {
          "category": "Device Security Practices",
          "options": {
            "high": "Yes, always",
            "low": "No, never",
            "medium": "Sometimes"
          },
          "question": "Do you regularly update your devices and use security tools like a VPN?"
        },
        "digital_threats": {
          "category": "Digital Threat Awareness",
          "options": {
            "high": "Familiar",
            "low": "Not familiar",
            "medium": "Somewhat familiar"
          },
          "question": "How familiar are you with digital threats such as malware, phishing, and ransomware?"
        },
        "hybrid_work": {
          "category": "Remote Work Security",
          "options": {
            "high": "Very confident",
            "low": "Not confident",
            "medium": "Somewhat confident"
          },
          "question": "How confident are you in maintaining security when working remotely (e.g., on public Wi-Fi)?"
        },
        "incidents_breaches": {
          "category": "Incident Reporting",
          "options": {
            "high": "Yes",
            "low": "No",
            "medium": "I have a general idea"
          },
          "question": "Do you know the correct procedure for reporting a security incident or breach?"
        },
        "passwords_accounts": {
          "category": "Password Management",
          "options": {
            "high": "I use a password manager",
            "low": "I reuse passwords",
            "medium": "I create unique, strong passwords"
          },
          "question": "How do you manage passwords for your work-related accounts?"
        },
        "phishing": {
          "category": "Phishing Identification",
          "options": {
            "high": "Very confident",
            "low": "Not confident",
            "medium": "Somewhat confident"
          },
          "question": "How confident are you in recognizing phishing attempts in emails or messages?"
        },
        "physical_security": {
          "category": "Physical Security Practices",
          "options": {
            "high": "Always",
            "low": "Rarely",
            "medium": "Sometimes"
          },
          "question": "How often do you secure your workspace (e.g., locking your computer, storing sensitive documents)?"
        },
        "secure_browsing": {
          "category": "Safe Browsing Habits",
          "options": {
            "high": "Yes, always",
            "low": "No, never",
            "medium": "Sometimes"
          },
          "question": "Do you avoid using public Wi-Fi or clicking on suspicious links when browsing?"
        }
      },
      "steps": {
        "finished": "Finished",
        "introduction": "Introduction",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "cancer": "the Danish Cancer Society",
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Invalid checksum",
        "option": "Answer not recognized"
      },
      "intro": {
        "button": "Start quiz",
        "text": "We’ll go through 5 emails in your Moxso inbox. Some of the emails might be from scammers trying to get access to sensitive data - you have to decide whether the email is phishing or not. Are you ready?",
        "title": "Ready to report?"
      },
      "multiple-choice": {
        "heading": "Find the error in this email",
        "text": "multiple-choice help text"
      },
      "options": {
        "email": "The email",
        "false": "This is NOT Phishing",
        "help": {
          "email": "The sender is NOT trusted",
          "false": "Email should NOT be reported",
          "link": "The link does NOT lead to a reliable destination",
          "not-phishing": "This is NOT Phishing",
          "true": "Email should be reported"
        },
        "link": "The link",
        "not-phishing": "This is NOT phishing",
        "true": "This IS Phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Is this a Phishing Email?",
        "text": "Determine whether this is a Phishing Email or not"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "This course cannot be accessed. Optional courses are locked, but mandatory training is always available.",
          "title": "This course is locked"
        },
        "quiz": {
          "description": "You've reached your training limit. Optional quizzes are locked for now.",
          "title": "Quiz limit reached"
        },
        "video": {
          "description": "You've reached your training limit. Optional videos are locked, but mandatory training is always available.",
          "title": "Video limit reached"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "This course cannot be accessed. Optional courses are locked, but mandatory training is always available.",
        "title": "This course is locked"
      },
      "quiz": {
        "description": "You've reached your training limit. Optional quizzes are locked for now.",
        "title": "Quiz limit reached"
      },
      "reset": "Resets Monday",
      "video": {
        "description": "You've reached your training limit. Optional videos are locked, but mandatory training is always available.",
        "limit_reached": "Limit reached",
        "title": "Video limit reached"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Advanced is a series for those who are particularly interested in cybersecurity and want to understand how the underlying mechanisms in hacking and cybersecurity works. If you just want to get a basic understanding of cybersecurity, then it will not be necessary for you to watch the videos in this series. If you want to learn more about hacking, cyberattacks and how to best increase your cybersecurity, look no further.",
          "title": "Advanced",
          "tooltip": "Become a hacking expert in no time"
        },
        "ai": {
          "text": "The AI series delves into the intricate role of artificial intelligence in cybersecurity. AI serves a dual purpose: it's a crucial tool for IT security professionals to identify and counter threats, while also being a powerful asset in the hands of hackers. This video series aims to enhance your awareness of AI-generated phishing schemes and guide you on safely leveraging AI to minimize errors and lower the risk of hacking. Ultimately, the series underscores that although AI is a powerful tool for both defenders and attackers, your behavior remains the key determinant in your security.",
          "title": "AI and cybersecurity",
          "tooltip": "Explore the complex role of AI in cybersecurity"
        },
        "compliance": {
          "text": "This category contains videos about important legislation, security standards and certifications that can help protect your workplace from digital threats. The videos give you insights into the NIS2 Directive and the DORA Regulation among others, which ensure robust cybersecurity measures and compliance with international standards. The videos provide insight into the importance of the regulations, how to achieve compliance, and the specific requirements they place on organizations' security and risk management. You'll also understand what the regulations mean for you and why they are worth your time.",
          "title": "Certifications and compliance",
          "tooltip": "Understand the importance of certifications and compliance"
        },
        "gdpr": {
          "text": "GDPR is a series that delves into the rules, requirements, and principles that have been set out in GDPR. The GDPR was introduced in 2018 and all businesses must now comply with the GDPR to ensure the integrity and protection of the personal data they process. The series covers the most relevant areas of GDPR that you need to know about so that you can process personal data correctly in your everyday life. This series includes videos aimed at everyone including private sector employees.",
          "title": "GDPR",
          "tooltip": "Learn the most important requirements and rules in GDPR and how you can comply with them in your everyday life"
        },
        "hacking": {
          "text": "The life of a hacker  is a series that teaches you about the people behind cyberattacks, the hackers of the world. We will take a closer look at some of the methods the hackers use to stay anonymous online and how they earn their money. The videos will further explain the different kinds of hackers and why they are så difficult to catch.",
          "title": "The life of a hacker",
          "tooltip": "Get to know the people behind cyberattacks, the hackers of the world"
        },
        "money_laundering": {
          "text": "Money laundering is a series that delves into the different methods used by criminals to launder money. The videos will explain the different methods used by criminals to launder money and how to detect and prevent money laundering.",
          "title": "Money laundering",
          "tooltip": "Learn the different methods used by criminals to launder money and how to detect and prevent money laundering"
        },
        "phishing": {
          "text": "Phishing is a series that delves into the most common cyberattack worldwide. Phishing attacks can both be an attack of its own or a way to launch other, and more advanced, cyberattacks. Phishing attacks are furthermore a kind of cyberattack where you as an employee solely bears the responsibility to avoid getting hacked, for example by avoiding clicking on a link in an e-mail. Phishing is an essential focus area in cybersecurity and the videos in this series will provide you with an understanding of phishing, how it’s carried out by the hackers and how to avoid becoming a victim of a phishing attack.",
          "title": "Phishing",
          "tooltip": "Discover the aspects of the most common cyberattack worldwide"
        },
        "physical_security": {
          "text": "Physical Security is a series that highlights the importance of good security in the workplace and at home. Cybersecurity is about more than the security of your devices, it's also about the security *surrounding* the devices. Many people are familiar with remote working, and we'll equip you to make this as secure as possible. In addition, with this series, you'll gain insight into everything from visitor management to cybersecurity on mobile devices and the risks of using public networks.",
          "title": "Physical security",
          "tooltip": "Learn why physical security is a crucial element in good cyber security"
        },
        "tips_and_tricks": {
          "text": "Tips and tricks is a series that will help increase your cybersecurity. You will learn specific, low practice ways to increase your personal security online and subsequently increase the security at your workplace. The videos will further explain why it's important to remember the advice on cybersecurity you may have received in the past.",
          "title": "Tips and tricks",
          "tooltip": "Learn how to increase your personal cybersecurity"
        },
        "types_of_hacking": {
          "text": "Types of hacking is a series that provides you with insights into the different methods hackers have at their disposal when they try to deceive you. Each episode gives you a basic understanding of the characteristics of a specific method of hacking, what the hackers can gain from using that method, the consequences it can have for you, if you are hacked, etc. By watching the videos in this series, you will be better equipped against hacking attacks in the future.",
          "title": "Types of hacking",
          "tooltip": "Get insights into the different methods used by hackers"
        },
        "uploads": {
          "text": "This category contains custom videos uploaded by your organization.",
          "title": "Uploads",
          "tooltip": "Watch videos uploaded by your organization for your specific security needs"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Error has been reported to our team with id: {errorId}.\n If you need immediate assistance, feel free to contact our support team at support{'@'}moxso.com.",
    "go_back": "Go back home",
    "text": "An unknown error occurred, and we couldn't complete your request. We're really sorry for the inconvenience. Please try again later.",
    "title": "Something went wrong"
  },
  "forms": {
    "fields": {
      "code": "One-time password",
      "email": "Email"
    },
    "placeholders": {
      "email": "name{'@'}company.com"
    }
  },
  "loading": "Loading",
  "locale": {
    "current": "English",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Login",
      "next": "Next",
      "send_one_time_code": "Send one time code",
      "try_again": "Resend code"
    },
    "choose_provider": "Choose provider",
    "loading": "Loading",
    "sso": {
      "validating": "Validating SSO"
    },
    "title": "Sign in",
    "two_factor": {
      "text": "We have sent a one-time password to your email.",
      "title": "Check your email"
    }
  },
  "mandatory": {
    "completed": {
      "text": "You have completed the featured content, your administrator has chosen for you.",
      "title": "Well done!"
    },
    "deadline": "Completion deadline: {date}",
    "next_training": "Next assigned training",
    "policy_fallback_title": "Policy",
    "quiz_questions": "{count} question | {count} questions",
    "retake": "Reassigned",
    "start_quiz": "Start quiz",
    "text": "Your assigned training",
    "title": "Assigned training",
    "view_policy": "View policy"
  },
  "navigation": {
    "breaches": "Breaches",
    "courses": "Courses",
    "exit": "Exit",
    "exit_onboarding": "Skip onboarding",
    "login": "Login",
    "logout": "Log out",
    "onboarding": "Introduction",
    "onboarding_finished": "Onboarding finished",
    "onboarding_intro": "Onboarding introduction",
    "onboarding_quiz": "Onboarding quiz",
    "overview": "Overview",
    "simulation_click": "Phishing simulation",
    "simulations": "Simulations",
    "videos": "Videos"
  },
  "onboarding": {
    "finished": {
      "button": "Start learning",
      "subtitle": "You have completed your onboarding! Great job, you're all set to start using Moxso. We’re excited to have you onboard and can’t wait to help you reach your goals!",
      "title": "That's it!"
    },
    "intro": {
      "form": {
        "button": "Save and continue",
        "help": "Pick the language you’d like to use for your learning experience.",
        "label": "Select your language",
        "placeholder": "Select language"
      },
      "header": {
        "description": "Welcome to your learning platform! We’re excited to have you here and ready to help you reach your goals. Let’s set up your profile and customize your experience.",
        "title": "Welcome to Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Complete this brief quiz to help us understand your current level, so we can tailor the training to fit your needs.",
        "title": "How well do you know cybersecurity?"
      }
    }
  },
  "overview": {
    "start_quiz": "Start a Quiz",
    "welcome": "Welcome back"
  },
  "partner_text": "The Moxso platform is presented in collaboration with {partner}.",
  "policies": {
    "cancel": {
      "text": "This policy has been canceled by your administrator.",
      "title": "Canceled Policy"
    },
    "continue": "Continue",
    "expired": {
      "text": "This policy has expired and is no longer available.",
      "title": "Expired Policy"
    },
    "focus": "Focus",
    "history": {
      "count": "{count} signed",
      "show_less": "Show less",
      "signed": "Signed: {date}",
      "subtitle": "Review signed policies",
      "title": "Policies",
      "view_more": "Show more"
    },
    "next": "Next",
    "overview": "Content overview",
    "policy": "Policy",
    "quiz": {
      "confirmation_card_locked": "You must complete the quiz to continue",
      "subtitle": "Show that you understand the policy by taking this quiz.",
      "subtitle_completed": "You have completed the quiz, confirm reading of policy to finish.",
      "title": "Quiz",
      "title_completed": "Quiz completed"
    },
    "reader": "Reader",
    "signature": {
      "button": "Confirm",
      "checkbox_label": "I have read the policy",
      "company": "Company",
      "completed": {
        "button": "Exit",
        "policy_completed": "Policy accepted",
        "subtitle": "Great job! You've  accepted the policy.",
        "title": "Policy accepted"
      },
      "ip_adress": "IP address",
      "subtitle": "By confirming, you acknowledge that you have read and understood the policy.",
      "title": "Confirm reading of policy",
      "user_agent": "User agent"
    },
    "this_policy_doesnt_exist_in_this_language": "This policy isn't available in English. Displaying {locale} version."
  },
  "quiz": {
    "analyze": {
      "text": "Analyze this email and get help",
      "title": "In doubt?"
    },
    "feedback": {
      "no": "No",
      "text": "Was this page helpful?",
      "thanks": "Thanks for your feedback!",
      "yes": "Yes"
    },
    "help": {
      "button": "Next question",
      "text": "We have analyzed the email and found the following result",
      "title": "Email analysis"
    },
    "intro": {
      "button": "Start quiz",
      "text": "We’ll go through 5 emails in your Moxso inbox. Some of the emails might be from scammers trying to get access to sensitive data - you have to decide whether the email is phishing or not. Are you ready?",
      "title": "Ready to report?"
    },
    "preview": "Email preview",
    "question": "Question {current} of {total}",
    "result": {
      "go_back": "Go to your overview",
      "mails": "Mail spotted | Mails spotted",
      "points": "Points earned",
      "text": {
        "bad": "Unfortunately, you only categorized {count} email correctly. But remember: Practice makes perfect! | Unfortunately, you only categorized {count} emails correctly. But remember: Practice makes perfect!",
        "good": "You categorized {count} emails correctly and completed the quiz. Keep up the good work!"
      },
      "title": {
        "bad": "Better luck next time",
        "good": "Well done!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "The resilience score measures your ability to withstand cyberattacks. The score is calculated based on your behavior in quizzes, videos, simulations, and your skills. The higher your resilience score, the better you are at protecting yourself and your workplace from cyberattacks.",
    "quizzing": {
      "text": "Improve your performance in multiple choice quizzes to strengthen your resilience.",
      "title": "Quizzes"
    },
    "show_breakdown": "Show breakdown",
    "simulations": {
      "text": "Safe phishing behavior improves your resilience. Don’t click and remember to report!",
      "title": "Simulations"
    },
    "skills": {
      "text": "Your skills depend on how you perform in quizzes. Correct answers increase resilience.",
      "title": "Skills"
    },
    "text": "The resilience score measures your ability to withstand cyberattacks.",
    "title": "Your resilience score",
    "videos": {
      "text": "Videos are an important part of your training. Boost resilience by watching videos.",
      "title": "Videos"
    }
  },
  "search": {
    "empty": "Search for something to get started...",
    "no_results": "No results found",
    "placeholder": "Search...",
    "popular": "Popular searches",
    "popular_terms": ["Ransomware", "Social Engineering"]
  },
  "simulation": {
    "alert": {
      "text": "This email is part of an automated phishing exercise, but don’t worry, it is just a test.",
      "title": "This is a phishing simulation"
    },
    "baseline": {
      "text": "We are currently testing your colleagues. We kindly ask you not to share this message.",
      "title": "Can You Keep a Secret?"
    },
    "branding": {
      "text": "We’re here to help so don’t hesitate to reach out.",
      "title": "This exercise was delivered by Moxso"
    },
    "delivered_by": {
      "text": "This exercise was delivered by Moxso on behalf of {companyName}. If you have any questions, feel free to reach out to {contactEmail}.",
      "title": "About this exercise"
    },
    "preview": "Email preview",
    "resilience_score": {
      "text": "Your resilience score measures your ability to withstand cyberattacks.",
      "title": "Your resilience score"
    },
    "submission": {
      "text": "You clicked a link and landed on a fake but convincing webpage. In a real phishing attack, your credentials could have been stolen. Luckily, this was just a test.",
      "title": "What just happened?"
    },
    "training": {
      "button": "Start your training"
    }
  },
  "simulations": {
    "count": "You have received {count} simulations by Moxso in the past 90 days.",
    "empty": {
      "text": "You have not recieved any simulations in the last 90 days.",
      "title": "No simulations found"
    },
    "joined": "Joined the Moxso training programme",
    "title": "Simulations",
    "tooltip": {
      "click": "You have clicked on the link in this simulation",
      "report": "You have reported this simulation",
      "submit": "You have logged in on this simulation."
    }
  },
  "sso": {
    "login_with": "Continue with {provider}",
    "or": "or use SSO",
    "redirect": "Redirecting"
  },
  "statistics": {
    "leaderboard": "Leaderboard",
    "missing_data": {
      "text": "You need to earn points to see your rank on the leaderboard",
      "title": "Earn points to see your rank"
    },
    "points_earned": "{count} points earned",
    "resilience_score": "Resilience score"
  },
  "videos": {
    "error": "Streaming is currently unavailable",
    "latest": "Latest videos",
    "more": "View more",
    "not_available_in_your_locale": "This video is unavailable in English. We have automatically swtiched to a different language.",
    "play": "Play video",
    "quiz": {
      "resume": "Resume quiz",
      "title": "Quiz"
    },
    "related": "Related videos",
    "related_videos": "Suggested videos",
    "title": "Videos",
    "watch_again": "Watch again"
  }
}
